import { render } from "./FormDataTable.vue?vue&type=template&id=6814c2d8&scoped=true"
import script from "./FormDataTable.vue?vue&type=script&lang=js"
export * from "./FormDataTable.vue?vue&type=script&lang=js"

import "./FormDataTable.vue?vue&type=style&index=0&id=6814c2d8&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6814c2d8"]])

export default __exports__